/* Prefer the configured Klaviyo embed; keep the established Shopify
   newsletter form available when the third-party form cannot render. */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-ff-newsletter]').forEach(function (root) {
      if (root.dataset.ffReady) return;
      root.dataset.ffReady = 'true';
      var vendor = root.querySelector('[data-ff-vendor]');
      var fallback = root.querySelector('[data-ff-fallback]');
      if (!vendor || !fallback) return;
      var vendorCopy = root.querySelector('[data-ff-vendor-copy]');
      var fallbackCopy = root.querySelector('[data-ff-fallback-copy]');
      var keepFallback = !!fallback.querySelector('[data-ff-submitted]');
      var pending = false;
      function sync() {
        pending = false;
        var form = vendor.querySelector('form, input[type="email"]');
        var rendered = !!form && vendor.getBoundingClientRect().height > 8 &&
          getComputedStyle(vendor).visibility !== 'hidden';
        var useVendor = rendered && !keepFallback;
        vendor.hidden = keepFallback;
        fallback.hidden = useVendor;
        if (vendorCopy) vendorCopy.hidden = !useVendor;
        if (fallbackCopy) fallbackCopy.hidden = useVendor;
      }
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(sync);
      }
      // An asynchronously arriving embed must not replace an email the
      // visitor is already entering into the native form.
      fallback.addEventListener('focusin', function () { keepFallback = true; sync(); });
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(vendor, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      }
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(vendor);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
